import React, { useEffect, useRef } from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

import MarkdownRenderer from './MarkdownRenderer';

const AIGeneratedContentModal = ({ title, content, onClose }) => {
    const modalRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') onClose();
            if (event.key === 'Tab' && modalRef.current) {
                const focusableElements = modalRef.current.querySelectorAll('button');
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];
                if (event.shiftKey) { if (document.activeElement === firstElement) { lastElement.focus(); event.preventDefault(); } }
                else { if (document.activeElement === lastElement) { firstElement.focus(); event.preventDefault(); } }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        modalRef.current?.querySelector('button')?.focus();
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    if (!content) return null;
    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center p-4" style={{ zIndex: 'var(--z-index-modal-backdrop)' }} role="dialog" aria-modal="true" aria-labelledby="ai-modal-title">
            <div ref={modalRef} className="bg-gray-800 bg-opacity-90 p-6 rounded-lg shadow-xl max-w-md w-full text-white relative">
                <h3 id="ai-modal-title" className="text-xl font-bold mb-4 text-blue-300 font-playfair">{t('aiGeneratedContentModal.title')}</h3>
                <p className="text-lg mb-6 leading-relaxed custom-scrollbar max-h-60 overflow-y-auto"><MarkdownRenderer>{content}</MarkdownRenderer></p>
                <button onClick={onClose} className="absolute top-3 right-3 p-2 rounded-full bg-gray-700 hover:bg-gray-600 text-white transition duration-300" aria-label={t('aiGeneratedContentModal.closeAriaLabel')}><LucideIcons.X size={20} /></button>
            </div>
        </div>
    );
};

export default AIGeneratedContentModal;
